<script setup lang="ts">
import type { VNode } from 'vue'
import { portal } from '@/motion/page-portal'

defineProps<{ component: VNode; path: string }>()
</script>

<template>
  <div class="route-page" :data-page-path="path">
    <Teleport
      to="#route-portal-content"
      :disabled="!portal.lifted || portal.to !== path"
    >
      <component :is="component" />
    </Teleport>
  </div>
</template>
